"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var buttonTypeProps = (0, _keyMirror.default)({
  button: null,
  selectableButton: null,
  selectableButtonTest: null
});

var CommunicationButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CommunicationButton, _React$Component);

  function CommunicationButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CommunicationButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CommunicationButton).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CommunicationButton, [{
    key: "getI18nString",
    value: function getI18nString() {
      var communicationKey = this.props.communicationKey;
      var i18nKey = communicationKey.toLowerCase();
      return _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods." + i18nKey
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          onClick = _this$props.onClick,
          setSelectedCommunicationMethod = _this$props.setSelectedCommunicationMethod,
          communicationKey = _this$props.communicationKey;
      onClick(upgradeData);
      setSelectedCommunicationMethod(communicationKey);
    }
  }, {
    key: "renderSelectableButtonTest",
    value: function renderSelectableButtonTest() {
      var communicationKey = this.props.communicationKey;
      var className = (0, _classnames.default)(communicationKey, 'p-x-8', 'p-y-4');
      return _react.default.createElement(_UISelectableButton.default, {
        block: true,
        className: className,
        onClick: this.handleClick,
        textLabel: this.getI18nString()
      });
    }
  }, {
    key: "renderSelectableButton",
    value: function renderSelectableButton() {
      var _this$props2 = this.props,
          image = _this$props2.image,
          communicationKey = _this$props2.communicationKey,
          useIllustration = _this$props2.useIllustration;
      return _react.default.createElement(_UISelectableButton.default, {
        className: communicationKey,
        size: "large",
        onClick: this.handleClick,
        textLabel: this.getI18nString()
      }, useIllustration ? _react.default.createElement(_UIIllustration.default, {
        name: image,
        height: 75
      }) : _react.default.createElement(_UIImage.default, {
        src: image,
        responsive: false,
        height: 75
      }));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var communicationKey = this.props.communicationKey;
      return _react.default.createElement(_UIButton.default, {
        use: "primary-white",
        className: communicationKey,
        block: true,
        onClick: this.handleClick
      }, this.getI18nString());
    }
  }, {
    key: "render",
    value: function render() {
      var buttonType = this.props.buttonType;
      var ButtonComponent = {
        button: this.renderButton(),
        selectableButton: this.renderSelectableButton(),
        selectableButtonTest: this.renderSelectableButtonTest()
      };
      return ButtonComponent[buttonType];
    }
  }]);
  return CommunicationButton;
}(_react.default.Component);

CommunicationButton.defaultProps = {
  buttonType: buttonTypeProps.button,
  useIllustration: true
};
CommunicationButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  image: _propTypes.default.string.isRequired,
  setSelectedCommunicationMethod: _propTypes.default.func.isRequired,
  communicationKey: _propTypes.default.string.isRequired,
  buttonType: _propTypes.default.oneOf(Object.keys(buttonTypeProps)),
  upgradeData: _propTypes.default.object.isRequired,
  useIllustration: _propTypes.default.bool
};
var _default = CommunicationButton;
exports.default = _default;
module.exports = exports.default;